"use client"

import { useLocation, useParams } from "react-router-dom"

import { extractBranchSlugFromAdminPath } from "@/shared/lib/branch/branch-admin-routing"
import { isReservedBranchSlug } from "@/shared/lib/routing/reserved-slugs"
import { useUserBranchAccess } from "@/features/auth/hooks/use-user-branch-access"
import { useBranchContextOverride } from "@/features/auth/hooks/use-branch-context-override"

export function useActiveBranchSlug() {
  const override = useBranchContextOverride()
  const params = useParams<{ branchSlug: string }>()
  const location = useLocation()
  const { primaryBranchSlug } = useUserBranchAccess()
  if (override) return override.branchSlug

  /*
   * React Router binds the second URL segment to `branchSlug` even when that segment is an Organization
   * route such as `settings`. The canonical path parser knows the flat-URL grammar, so it must win here.
   * Otherwise `/workspace/settings/…` leaks `settings` into branch-aware links and produces URLs such as
   * `/workspace/settings/branches/:id`.
   */
  const fromPath = extractBranchSlugFromAdminPath(location.pathname)
  if (fromPath) return fromPath

  const fromParams = params?.branchSlug
  return fromParams && !isReservedBranchSlug(fromParams) ? fromParams : primaryBranchSlug ?? ""
}
